import { useCallback } from 'react';
import sendNativeEvent from '../send-native-event';

const useReloadPurchaseProcess = () => {
  const reloadPurchaseProcess = useCallback(async () => {
    window.location.href = '/purchase';
    return null;
  }, []);

  const isCarvanaNativeApp = /CarvanaNativeWebView/gi.test(
    navigator?.userAgent
  );

  if (isCarvanaNativeApp) {
    return sendNativeEvent({
      event: 'speed_bump',
      payload: {},
      source: 'purchase'
    });
  }

  return reloadPurchaseProcess;
};

export default useReloadPurchaseProcess;
